import Vue from 'vue';
/* import {  } from '@/scripts/constants/test'; */

let previousScrollPosition = 0;

const lockScroll = () => {
  const [app] = document.querySelectorAll('.app');
  const [menuContent] = document.querySelectorAll('.menu__content');

  previousScrollPosition = window.scrollY;

  if (app) {
    app.style.top = `${-previousScrollPosition}px`;
    app.style.minHeight = `calc(100vh + ${previousScrollPosition}px)`;
  }

  if (menuContent) {
    menuContent.style.top = `${previousScrollPosition}px`;
  }
};

const unlockScroll = () => {
  const [app] = document.querySelectorAll('.app');
  const [menuContent] = document.querySelectorAll('.menu__content');

  if (app) {
    app.style.top = '0px';
    app.style.minHeight = '100vh';
  }

  if (menuContent) {
    menuContent.style.top = '0px';
  }

  window.scrollTo(0, previousScrollPosition);
};

const getRef = nodeCandidate => {
  const isArray = Array.isArray(nodeCandidate);
  const element = isArray ? nodeCandidate[0] : nodeCandidate;
  const node = element instanceof Vue && element.$el ? element.$el : element;

  return node;
};

const scrollToBottom = () => {
  window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
};

/*  */
export { lockScroll, unlockScroll, getRef, scrollToBottom };
